import React from 'react';

const ReviewIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
      <path d="M11.8121 16.6855L12.66 15.4928L10.824 14.917L7.85594 10.7421L4.88788 14.917L0 16.4496L3.0535 20.5626L3.00069 25.6848L7.85594 24.0518L9.14625 24.4858L4.95213 18.8364L11.8121 16.6855Z" />
      <path d="M31.9998 16.4496L27.112 14.917L24.144 10.7421L21.1759 14.917L19.3032 15.5042L20.143 16.6855L27.0029 18.8364L22.7939 24.5058L24.144 24.0518L28.9992 25.6849L28.9463 20.5626L31.9998 16.4496Z" />
      <path d="M15.04 2.89832H16.915V7.97632H15.04V2.89832Z" />
      <path d="M9.49219 7.52502L10.8178 6.1994L12.9849 8.36653L11.6593 9.69216L9.49219 7.52502Z" />
      <path d="M18.9648 8.36755L21.1319 6.20047L22.4576 7.52609L20.2905 9.69318L18.9648 8.36755Z" />
      <path d="M23.8334 19.8663L18.9455 18.3337L15.9775 14.1587L13.0095 18.3337L8.12158 19.8663L11.1751 23.9792L11.1222 29.1014L15.9775 27.4684L20.8328 29.1016L20.7799 23.9792L23.8334 19.8663Z" />
      </g>
      <defs>
      <clipPath id="clip0">
      <rect width="32" height="32" />
      </clipPath>
      </defs>
    </svg>
  );
};

export default ReviewIcon;
